import React, { useEffect } from "react";
import { Container, Button, } from "react-bootstrap";
import { connect } from "react-redux";
import { UpdateVoucherStatusApi, GetApproveAllVoucherApi, DeleteVoucherApi } from "./VoucherAction";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { previewVoucher } from '../../../../../global/globalFunctions'
import MaterialTable from "material-table";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import moment from "moment";
import swal from 'sweetalert';
const tableRef = React.createRef()


const VoucherVerification = (props) => {
    const permissions = JSON.parse(window.localStorage.getItem("permissions"));
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
    };

    const handleDelete = (rowData) => {
        swal({
            title: "Are you sure ?",
            text: "Do you want to delete this voucher ?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            showCancelButton: true,
        }).then((willDelete) => {
            if (willDelete) {
                props.DeleteVoucherApi(rowData._id)
                tableRef.current && tableRef.current.onQueryChange()
            }
        });
    };

    useEffect(() => {
        props.setHeading("Voucher Verification");
    }, []);

    function ApproveAllVoucher() {
        props.GetApproveAllVoucherApi({})
        tableRef.current && tableRef.current.onQueryChange()
    }

    return (
        <>
            <Container fluid>
                <div style={{ textAlign: 'center', marginBottom: '35px' }}>
                    <Button variant="contained" size="large" onClick={ApproveAllVoucher} style={{ fontWeight: 'bold', padding: "10px", backgroundColor: 'lightblue' }}> Approve All Pending Voucher </Button>
                </div>
                <MaterialTable
                    tableRef={tableRef}
                    title="Voucher Verification"
                    columns={[
                        {
                            title: "S.No", field: "sequenceNumber",
                            cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                            title: "Voucher ID", field: "voucherManualId",
                            cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                        },
                        {
                            title: "Voucher Date",
                            field: "vocDate",
                            render: (rowData) => {
                                const voucherDate = rowData.vocDate;
                                const createdTime = moment(rowData.createdAt).format('LT');
                                return `${voucherDate} ${createdTime}`;
                            }
                        },
                        {
                            title: "Status", field: "status",
                            render: (rowData) => (
                                <div
                                    style={{
                                        backgroundColor: rowData.status === "Approved" ? "#9FD983" : rowData.status === "Pending" ? "#f7cb74" : rowData.status === "Disapproved" ? "#F8B8A2" : "#f7cb74",
                                        padding: "5px 16px 7px",
                                        borderRadius: "10px",
                                        textAlign: "center",
                                        width: "max-content"
                                    }}
                                >
                                    {rowData.status}
                                </div>
                            ),
                        },
                        { title: "Created By", field: "userDetails.userName" },
                        { title: "Approved By", field: "approvelUser.userName" },
                        { title: "Approved Date", field: "voucherApprovelDate" },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/voucher/get_all_voucher_user?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: 'GET',
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    detailPanel={(rowData) => {
                        return (
                            <MaterialTable
                                title="Voucher Details"
                                columns={[
                                    { title: "Account Title", field: "accountTittle" },
                                    { title: "Bill", field: "billNumber" },
                                    { title: "Description", field: "voucherDescription" },
                                    { title: "Amount", field: "voucherAmount", render: rowData => `${rowData.voucherAmount.toLocaleString()}/-` },
                                    { title: 'Cheque No', field: 'chequeNo' },
                                    { title: 'Cheque Date', field: 'chequeDate' },
                                    {
                                        title: "Account Type", field: "accountType",
                                        render: rowData => rowData.accountType === 1 ? "Credit" : rowData.accountType === 2 ? "Debit" : ""
                                    }
                                ]}
                                data={rowData.voucherData}
                                options={{
                                    toolbar: false,
                                    search: false,
                                    actionsColumnIndex: -1,
                                    exportButton: false,
                                    exportAllData: false,
                                    paging: false,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: "sticky",
                                        top: 0,
                                        color: "#00BBBB",
                                        fontWeight: "550",
                                        fontSize: "14px",
                                    },
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: "#ededed",
                                        // fontWeight: rowData.accountType === 1 ? "bold" : "normal",
                                        color: "black"
                                    }),
                                }}
                            />
                        );
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                        (rowData) => ({
                            hidden: Checkpermissions("permissionsCatName", "Voucher Approvel Permission") === true ? true : false,
                            disabled: rowData.status === 'Pending' ? false : true,
                            icon: () => <TaskAltIcon style={{ color: rowData.status === 'Pending' ? 'green' : '#cccccc' }} />,
                            tooltip: "Approve Voucher",
                            onClick: (event, rowData) => {
                                const status = 'Approved'
                                props.UpdateVoucherStatusApi(rowData._id, status);
                                tableRef.current && tableRef.current.onQueryChange();
                            },
                        }),
                        (rowData) => ({
                            hidden: Checkpermissions("permissionsCatName", "Voucher Approvel Permission") === true ? true : false,
                            disabled: rowData.status === 'Pending' ? false : true,
                            icon: () => <CancelIcon style={{ color: rowData.status === 'Pending' ? '#dc3545' : '#cccccc' }} />,
                            tooltip: "Cancel Voucher",
                            onClick: (event, rowData) => {
                                const status = 'Disapproved'
                                props.UpdateVoucherStatusApi(rowData._id, status);
                                tableRef.current && tableRef.current.onQueryChange();
                            },
                        }),
                        (rowData) => ({
                            icon: () => <PrintIcon style={{ color: '#1D1D1D' }} />,
                            tooltip: "Print Voucher",
                            onClick: (event, rowData) => {
                                previewVoucher(rowData, rowData.status);
                            },
                        }),
                        (rowData) => ({
                            hidden: Checkpermissions("permissionsCatName", "Voucher Delete Permission") === true ? true : false,
                            disabled: rowData.status === 'Pending' ? false : true,
                            icon: () => <DeleteOutlineIcon style={{ color: rowData.status === 'Pending' ? '#c40417ff' : '#cccccc' }} />,
                            tooltip: "Delete Voucher",
                            onClick: (event, rowData) => {
                                handleDelete(rowData);
                            },
                        }),
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        UpdateVoucherStatusApi: (id, status) => dispatch(UpdateVoucherStatusApi(id, status)),
        DeleteVoucherApi: (id) => dispatch(DeleteVoucherApi(id)),
        GetApproveAllVoucherApi: () => dispatch(GetApproveAllVoucherApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(VoucherVerification);